import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { ReBaseData } from '../../../../shared/utils/re-base-data';
import { WizardStep } from '../../../models/wizardStep';
import { map } from 'rxjs/operators';
import { ConfirmationService } from '../../../services/confirmation.service';
import { TrackingService } from '../../../services/tracking.service';
import { StorageService } from '../../../services/storage.service';
import { TARIFF_CONTEXT } from '../../../enums/tariffContext.enum';

@Component({
    selector: 'bdo-wizard',
    templateUrl: './wizard.component.html',
    styleUrls: ['./wizard.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WizardComponent implements OnDestroy {

  public activeStep: number = 1;
  public wizardSteps: Array<WizardStep>;
  public subscriptions = new Subscription();

  protected reBaseData = ReBaseData;

  constructor(
    public confirmationService: ConfirmationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private trackingService: TrackingService
  ) {
    const tariffContext: TARIFF_CONTEXT = activatedRoute.snapshot.data['tariffContext'];
    if (tariffContext) {
      StorageService.setTariffContext(tariffContext);
    }

    if (activatedRoute?.data['_value']['wizardSteps']){
      this.wizardSteps = this.filterOptionalWizardSteps(activatedRoute?.data['_value']['wizardSteps']);
      this.subscriptions.add(
        this.router.events
          .pipe(
            filter((event) => (event instanceof NavigationEnd)),
            map(() => this.activatedRoute.snapshot.firstChild.url[0].path),
            map((path) => this.wizardSteps.findIndex((step) => path === step.path)) // find wizard step based on current path
          )
          .subscribe({ next: indexOfCurrentStep => this.activeStep = indexOfCurrentStep + 1 }) //activeSteps start at 1
      );
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public onConfirmationResult($event: boolean) {
    if ($event) {
      this.trackingService.postSimpleTracking('Wizard', 'cancelled');
    }
    this.confirmationService.confirm($event);
  }

  private filterOptionalWizardSteps(wizardSteps: WizardStep[]): WizardStep[] {
    return wizardSteps?.filter((step) => !step.optional || (step.optional && !!step.condition()));
  }

}
